import {RESUMEN_VENTA} from "../../../components/ventas/routes";


export default {
  namespaced: true,
  state: {
    registros: [],
    error: "",
    isLoading: false
  },
  mutations: {
    'SET_REGISTROS'(state, payload) {
      state.registros = payload.map(r => {
        const subtotal = r.neto + r.iva
        const devSubtotal = r.devolucion_neto + r.devolucion_iva
        return {
          ...r,
          subtotal,
          devSubtotal,
          total: subtotal - devSubtotal,
          venta_neta: r.neto - r.devolucion_neto
        }
      }).sort((a, b) => b.venta_neta - a.venta_neta)
    },
    'ERROR_REQUEST'(state, payload) {
      state.error = payload
    },
    'SET_LOADING'(state, payload) {
      state.isLoading = payload
    }
  },
  actions: {
    reduceRegistros(context, registros) {
      return registros.reduce((accumulate, actual) => {
        const find = accumulate.find(item => item.vendedor.id.value === actual.vendedor.id.value)
        if (find) {
          const {neto, iva, devolucion_iva, devolucion_neto} = find
          actual.neto += neto
          actual.iva += iva
          actual.devolucion_iva += devolucion_iva
          actual.devolucion_neto += devolucion_neto
          return [...accumulate.filter(item => item.vendedor.id.value !== actual.vendedor.id.value), actual]
        } else {
          return [...accumulate, actual]
        }
      }, [])
    },
    loadRegistros({commit, dispatch}, query) {
      commit("ERROR_REQUEST", "")
      commit("SET_LOADING", true)
      this._vm.$axios.get(RESUMEN_VENTA + query)
        .then(response => {
          return dispatch("reduceRegistros", response.data.items)
        })
        .then(response => {
          commit("SET_REGISTROS", response)
          commit("SET_LOADING", false)
        })
        .catch(e => {
          commit("ERROR_REQUEST", e)
          commit("SET_REGISTROS", [])
          commit("SET_LOADING", false)
        })
    }
  },
  getters: {
    registros: state => state.registros,
    error: state => state.error,
    loader: state => state.isLoading
  }
}
